module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('box-widget', {
    attrs: {
      "icon": "star"
    }
  }, [_c('template', {
    slot: "head"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.auto-publication')))]), _c('template', {
    slot: "content"
  }, [_c('b-form-group', [_c('b-form-radio-group', {
    attrs: {
      "disabled": _vm.readonly,
      "options": _vm.options
    },
    on: {
      "change": _vm.toggleAutoPublish
    },
    model: {
      value: (_vm.localValue),
      callback: function($$v) {
        _vm.localValue = $$v
      },
      expression: "localValue"
    }
  })], 1)], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-037b60b6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auto-publish-box/AutoPublishBox.vue
// module id = 1996
// module chunks = 1